<template>
  <div id="pagination">
    <el-pagination
      background
      layout="sizes,prev, pager, next"
      :page-sizes="pageSizes"
      :page-size="perSize"
      :total="totalSize"
      :current-page="currentPage"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    perSize: {
      type: Number,
      default: 10,
    },
    totalSize: {
      type: Number,
      default: null,
    },
    currentPage: {
      type: Number,
      default: null,
    },
  },
  methods: {
    // 页面大小 改变时会触发
    handleSizeChange(pageSizesVal) {
      console.log('handleSizeChange')
      this.$emit('setPageSizesVal', pageSizesVal)
    },
    // 当前页码数 改变时会触发
    handleCurrentChange(curPageVal) {
      this.$emit('setCurPageVal', curPageVal)
    },
  },
}
</script>

<style lang="scss" scoped>
#pagination {
  text-align: right;
}
::v-deep .el-pagination.is-background {
  .btn-prev,
  .btn-next {
    background-color: white;
    border-radius: 50%;
  }
  .btn-prev:hover,
  .btn-next:hover {
    color: rgb(59, 131, 246);
  }
  .el-pager {
    li {
      background-color: white;
      border-radius: 50%;
    }
  }
}
</style>
